<basetile-renderer #mdChronoCodeTileRenderer>
  <div target="title">
    <wiz-label width="100%" [wizLabel]="data.code" [wizTextBehavior]="'truncate'"></wiz-label>
  </div>
  <div target="actionButtons">
    <wiz-hgroup height="100%" padding="2px" [verticalAlign]="'center'" [horizontalAlign]="'end'">
      <wiz-icon #titleActionButton (click)="onDuplicate($event)" [wizTooltip]="'$.common.clone.$'">duplicate</wiz-icon>
    </wiz-hgroup>
  </div>
  <div target="complementaryTitle">
    <wiz-label [wizLabel]="startEndDate" [wizTextBehavior]="'truncate'"></wiz-label>
  </div>
  <div target="body">
    <wiz-vgroup height="100%">
      <wiz-label class="componentLabel" [wizLabel]="data.trsLabel"></wiz-label>
      <wiz-label [wizLabel]="sequence" [wizTextBehavior]="'wordWrap'" [wizNbLine]="3" style="font-size: 10px">
      </wiz-label>
    </wiz-vgroup>
  </div>
</basetile-renderer>
